<template>
  <v-container>
    <v-layout row wrap>
      <v-flex x12 md2 offset-md2 mb-3>
        <h1>Benvenuto {{nome}}</h1>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex offset-md2 mb-3>
        <AlertDialog v-if="!isAuthorized" />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2 mb-3>
        <h2>Ecco l'elenco dei tuoi corsi:</h2>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs5 md3 lg2 offset-md2 mb-3 d-flex>
        <v-select v-model="filter" :items="parameters" label="Filtro Corsi"></v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-layout row v-for="course in filteredCourses" :key="course.id">
      <v-flex xs12 md8 offset-md2 pb-1>
        <v-card class="homeCard selectable" @click="selectCourse(course.id, course.status, course.nome)">
          <v-layout row wrap mb-2>
            <v-flex xs6 pa-2 class="text-xs-center">
              <div class="caption homeCardHeaderText">Corso</div>
              <div class="homeCardText">{{course.nome}}</div>
            </v-flex>
            <v-flex xs6 pa-2 class="text-xs-center">
              <div class="caption homeCardHeaderText">Stato</div>
              <div>
                <v-chip :class="course.colorChip">{{course.status}}</v-chip>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2 pb-1>
        <v-card>
          <v-alert :value="flag" color="warning" class="text-xs-center">Al momento la tua lista corsi è vuota</v-alert>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
import * as firebase from "firebase";
import { CoursesMixin } from "../mixins/CoursesMixin";
import AlertDialog from "../components/AlertDialog";
export default {
  mixins: [CoursesMixin],
  components: { AlertDialog },
  data: () => ({
    loaded: false,
    flag: false, 
    nome: "",
    registeredCourses: [],
    filteredCourses: [],
    parameters: ["Tutti", "Terminati", "In corso", "Da iniziare"],
    filter: "Tutti"
  }),
  computed: {
    //controlla se l'utente è admin
    isAuthorized() {
      return this.$store.getters.getAuthorized === "1";
    }
  },
  methods: {
    //metodo per la creazione di un array di corsi a cui l'utente è iscritto
    setRegisteredCourse() {
      var signedIn = [];
      const user = firebase.auth().currentUser;
      db.collection("iscritti")
        .where("id_utente", "==", user.uid)
        .get()
        .then(list => {
          list.forEach(element => {
            if (element.data().id_utente == user.uid) {
              signedIn.push(element.data().id_corso);
            }
          });
          this.$store.dispatch("setRegisteredCourses", signedIn).then(() => {
            if (signedIn.length === 0) {
              this.flag = true;
              this.loaded = true;
            } else {
              this.flag = false;
              this.getCourses(signedIn);
            }
          });
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel caricamento della collection 'iscritti'(" +
              error +
              ")"
          );
        });
    },

    //metodo per l'assegnazione degli array "registeredCourses" e "filteredCourses" contenenti i corsi del db e assegnazione di uno status
    getCourses(courses) {
      const currentDay = new Date().toISOString().substr(0, 10);
      var status = "";
      var colorChip = "";
      courses.forEach(element => {
        status = "";
        colorChip = "";
        db.collection("corsi")
          .doc(element)
          .get()
          .then(doc => {
            if (
              currentDay < doc.data().data_fine &&
              currentDay >= doc.data().data_inizio
            ) {
              status = "In corso";
              colorChip = "yellow lighten-1";
            } else if (currentDay < doc.data().data_inizio) {
              status = "Da iniziare";
              colorChip = "green lighten-1";
            } else if (currentDay >= doc.data().data_fine) {
              status = "Terminato";
              colorChip = "red lighten-1";
            }
            const course = {
              nome: doc.data().nome,
              status: status,
              id: doc.id,
              colorChip: colorChip
            };
            this.registeredCourses.push(course);
            this.filteredCourses.push(course);
            this.loaded = true;
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema nel caricamento della collection 'corsi'(" +
                error +
                ")"
            );
          });
      });
    }
  },
  watch: {
    //metodo per il funzionamento del filtro per i corsi
    filter(filter) {
      const courses = this.registeredCourses;
      this.filteredCourses = [];
      courses.forEach(course => {
        if (filter === "Tutti") {
          this.filteredCourses.push(course);
        } else if (filter === "Terminati") {
          if (course.status === "Terminato") {
            this.filteredCourses.push(course);
          }
        } else if (filter === "In corso") {
          if (course.status === "In corso") {
            this.filteredCourses.push(course);
          }
        } else if (filter === "Da iniziare") {
          if (course.status === "Da iniziare") {
            this.filteredCourses.push(course);
          }
        }
      });
      if (this.filteredCourses.length === 0) {
        this.flag = true;
      } else {
        this.flag = false;
      }
    }
  },
  created() {
    //metodo per il recupero del nome utente loggato e inizializzazione del recupero corsi a cui è iscritto
    var user = this.$store.getters.getUserLoged;
    db.collection("utenti")
      .doc(user.uid)
      .get()
      .then(usr => {
        this.nome = usr.data().nome;
        this.setRegisteredCourse();
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore: problema nel caricamento del nome utente(" + error + ")"
        );
      });
  }
};
</script>
